// Unified Navbar Logic

document.addEventListener('turbolinks:load', () => {

  // --- Logic for Tour Secondary Navbar (Vanilla JS) ---
  // This handles the active state for a secondary navigation bar on tour pages.
  const navItems = document.querySelectorAll('.nav-item-tour');
  if (navItems.length > 0) {
    const currentUrl = window.location.pathname;

    navItems.forEach(item => {
      const link = item.querySelector('.nav-link-tour');
      // Set active on page load
      if (link && link.getAttribute('href') === currentUrl) {
        item.classList.add('active');
      }
      // Set active on click
      item.addEventListener('click', function() {
        navItems.forEach(i => i.classList.remove('active'));
        this.classList.add('active');
      });
    });
  }

  // --- Logic for Desktop Megamenu (Vanilla JS) ---
  // This handles the city selection and tour display in the new megamenu.
  const megamenus = document.querySelectorAll('.dropdown-menu.megamenu');
  megamenus.forEach(megamenu => {
    const cityItems = megamenu.querySelectorAll('.megamenu-city-item');
    const tourContents = megamenu.querySelectorAll('.megamenu-tours-content');

    // Set default active state on load (first city and its tours)
    if (cityItems.length > 0 && tourContents.length > 0) {
      // Ensure no items are active before setting the default
      cityItems.forEach(item => item.classList.remove('active'));
      tourContents.forEach(content => content.classList.remove('active'));
      
      cityItems[0].classList.add('active');
      tourContents[0].classList.add('active');
    }

    // Handle hover event to switch cities
    cityItems.forEach(cityItem => {
      cityItem.addEventListener('mouseover', () => {
        // Do nothing if it's already the active item
        if (cityItem.classList.contains('active')) return;

        // Deactivate all other cities and tour lists
        cityItems.forEach(item => item.classList.remove('active'));
        tourContents.forEach(content => content.classList.remove('active'));

        // Activate the hovered city
        cityItem.classList.add('active');
        
        // Activate the corresponding tour list
        const targetId = cityItem.dataset.cityTarget;
        const targetContent = megamenu.querySelector(`#${targetId}`);
        if (targetContent) {
          targetContent.classList.add('active');
        }
      });
    });
  });

  // --- Existing jQuery Logic ---
  // The following logic was already in the file and is preserved.
  
  // Tour nav items (jQuery version, might be redundant but preserved for safety)
  let tourNavItem = $('.tour-nav-item');
  if (tourNavItem.length > 0) {
    $(tourNavItem).on('click', function(){
        $(tourNavItem).removeClass('active');
        $(this).addClass('active');
    });
    // Active on page load (jQuery version)
    let activeNavItem = $(`a[href='${window.location.pathname}']`).parent('.tour-nav-item');
    if (activeNavItem.length > 0) {
      $(tourNavItem).removeClass('active');
      $(activeNavItem).addClass('active');
    }
  }

  // Dropdown submenus (for standard bootstrap dropdowns)
  $('.dropdown-menu:not(.megamenu) .dropdown-menu-item').on({
      "mouseenter": function(e) {
          $(this).find('.dropdown-submenu').first().addClass('show');
      },
      "mouseleave": function(e) {
          $(this).find('.dropdown-submenu').first().removeClass('show');
      }
  });

  // Dropdown with click for nested menus
  $('.dropdown-menu:not(.megamenu) a.dropdown-toggle').on('click', function(e) {
      if (!$(this).next().hasClass('show')) {
          $(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
      }
      var $subMenu = $(this).next('.dropdown-menu');
      $subMenu.toggleClass('show');

      $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
          $('.dropdown-submenu .show').removeClass('show');
      });
      return false;
  });

  // Navbar search bar functionality
  let searchIcon = $('.search-icon');
  let searchBox = $('.search-box');
  let closeIcon = $('.close-icon');

  $(searchIcon).on('click', function() {
      $(searchBox).addClass('active');
  });

  $(closeIcon).on('click', function() {
      $(searchBox).removeClass('active');
  });

  // Navbar background change on scroll
  let navbar = $('.app-navbar');
  if (navbar.length > 0) {
    let elementsToToggle = $('.navbar-brand, .nav-link, .search-icon-filter, .menu-icon-filter');
    const toggleScrolledClass = (isScrolled) => {
        navbar.toggleClass('scrolled', isScrolled);
        elementsToToggle.toggleClass('scrolled', isScrolled);
    };

    if (window.location.pathname === '/' || window.location.pathname.includes('/tours/')) {
        $(window).on('scroll', function() {
            toggleScrolledClass($(window).scrollTop() > 50);
        });
        // Initial check
        toggleScrolledClass($(window).scrollTop() > 50);
    } else {
        toggleScrolledClass(true);
    }
  }

  // Navbar mobile menu functionality
  let mobileMenuIcon = $('.mobile-menu-icon');
  let mobileMenu = $('.mobile-menu');
  let mobileMenuCloseIcon = $('.mobile-menu-close-icon');

  if (mobileMenuIcon.length > 0) {
    $(mobileMenuIcon).on('click', function() {
        $(mobileMenu).addClass('active');
    });
  }
  
  if (mobileMenuCloseIcon.length > 0) {
    $(mobileMenuCloseIcon).on('click', function() {
        $(mobileMenu).removeClass('active');
    });
  }
});
